const parseAnswers = (answers, labels = {}) => {
  if (!answers) return [];

  try {
    const parsedAnswers = typeof answers === 'string' ? JSON.parse(answers) : answers;
    const answerMap = parsedAnswers || {};
    const mappedQuestionIds = new Set();

    const mappedAnswers = Object.keys(labels)
      .sort((a, b) => Number(a) - Number(b))
      .filter((id) => answerMap[id] !== undefined)
      .map((id) => {
        mappedQuestionIds.add(id);
        return {
          id,
          question: labels[id] || `Question ${id}`,
          answer: answerMap[id],
        };
      });

    const unmappedAnswers = Object.entries(answerMap)
      .filter(([id]) => !mappedQuestionIds.has(id))
      .map(([id, answer]) => ({
        id,
        question: `Question ${id}`,
        answer,
      }));

    return [...mappedAnswers, ...unmappedAnswers];
  } catch (error) {
    console.warn('Unable to parse quick request answers:', error);
    return [];
  }
};

const parseDeviceImages = (deviceImage) => {
  if (!deviceImage) return [];
  if (Array.isArray(deviceImage)) return deviceImage;

  const value = String(deviceImage).trim();

  try {
    const parsedImages = JSON.parse(value);
    if (Array.isArray(parsedImages)) return parsedImages;
  } catch (error) {
    // Some quick-request image payloads arrive as [url,url] instead of JSON.
  }

  const markdownLinkMatch = value.match(/\((https?:\/\/.*)\)$/);
  const imageList = markdownLinkMatch ? markdownLinkMatch[1] : value.replace(/^\[/, '').replace(/\]$/, '');

  return imageList
    .split(',')
    .map((url) => url.trim())
    .filter((url) => url.startsWith('http'));
};

const getHighestBidAmount = (data) => {
  const amount = Number(data.highest_bid_amount ?? 0);
  return Number.isFinite(amount) && amount > 0 ? amount : 0;
};

export const mapQuickRequestToApplication = (request, labels) => ({
  id: request.reference_no,
  referenceNo: request.reference_no,
  storeCode: request.store_code,
  storeName: request.store_name,
  storeAddress: request.address,
  storeEmail: request.email,
  storeMobile: request.mobile,
  deviceModel: [request.brand, request.model].filter(Boolean).join(' ') || request.model || '-',
  customerName: request.customer_name || '-',
  customerMobile: request.customer_mobile,
  imeiNumber: request.imei_number,
  date: request.created_at || request.updated_at || '-',
  expiresAt: request.expires_at,
  endTime: request.expires_at,
  condition: String(request.device_condition ?? '').trim() || '-',
  status: request.status === 'questions_completed' ? 'Pending' : request.status,
  rawStatus: request.status,
  highestBid: getHighestBidAmount(request),
  images: parseDeviceImages(request.device_image),
  checkDetails: parseAnswers(request.answers, labels),
});

